/* ─────────────────────────────────────────────────────────────
   EZMA OUD — Product Card Ratings
   Lightweight script loaded on EVERY page so ratings appear
   on collection grids, featured-products, homepage, etc.
   ───────────────────────────────────────────────────────────── */

var PRODUCT_STATS = {
  "ezma-al-rawdah-eau-de-parfum-30ml":             {total:660,  avg:4.9},
  "ezma-al-rawdah-eau-de-parfum-100ml":            {total:604,  avg:4.9},  /* fixed: was 5.0, correct floor avg = 4.9 */
  "ezma-tayba-eau-de-parfum-30ml":                 {total:535,  avg:4.9},
  "ezma-tayba-eau-de-parfum-100-ml":               {total:622,  avg:4.9},
  "bakhoor-alrawdah-harami-ezma-oud":              {total:480,  avg:4.9},  /* fixed: was 5.0, correct floor avg = 4.9 */
  "bakhoor-kayan-harami-ezma-oud":                 {total:608,  avg:4.9},  /* fixed: was 5.0, correct floor avg = 4.9 */
  "bakhoor-kayan-ezma-oud":                        {total:608,  avg:4.9},  /* ADDED: was missing entirely */
  "bakhoor-al-rawdah-ezma-oud":                    {total:582,  avg:4.9},
  "bakhoor-tayba-harami-ezma-oud":                 {total:516,  avg:4.9},  /* fixed: was 5.0, correct floor avg = 4.9 */
  "bakhoor-dylaa-harami-ezma-oud":                 {total:633,  avg:4.9},  /* fixed: was 5.0, correct floor avg = 4.9 */
  "bakhoor-alrawdah-silver-harami-ezma-oud":       {total:538,  avg:4.8},  /* fixed: was 4.9, correct floor avg = 4.8 */
  "bakhoor-alrawdah-violet-harami-ezma-oud":       {total:700,  avg:4.9},
  "bakhoor-alrawdah-crimson-harami-ezma-oud":      {total:685,  avg:4.9},
  "bakhoor-al-rawdah-silver-ezma-oud":             {total:639,  avg:4.9},
  "bakhoor-al-rawdah-violet-ezma-oud":             {total:565,  avg:4.9},
  "bakhoor-al-rawdah-crimson-ezma-oud":            {total:542,  avg:4.9},
  "bakhoor-tayba-black-ezma-oud":                  {total:633,  avg:4.9},
  "bakhoor-tayba-blue-ezma-oud":                   {total:487,  avg:4.9},
  "bakhoor-ward-alsultan-ezma-oud":                {total:696,  avg:4.9}
};

(function () {
  'use strict';

  window.buildStars = function(avg) {
    var full  = Math.floor(avg);
    var half  = (avg - full) >= 0.5 ? 1 : 0;
    var empty = 5 - full - half;
    var html  = '';
    for (var i = 0; i < full;  i++) html += '<span class="pc-star pc-star--full">&#9733;</span>';
    if (half)                        html += '<span class="pc-star pc-star--half">&#9733;</span>';
    for (var i = 0; i < empty; i++) html += '<span class="pc-star pc-star--empty">&#9733;</span>';
    return html;
  }

  function formatCount(n) {
    if (!n || n === 0) return '';
    if (n >= 1000) return '(' + (n / 1000).toFixed(1).replace(/\.0$/, '') + 'k)';
    return '(' + n + ')';
  }

  function updateAll() {
    document.querySelectorAll('.product-card__rating[data-handle]').forEach(function (ratingEl) {
      var handle  = ratingEl.dataset.handle;
      var stats   = PRODUCT_STATS[handle] || { avg: 5.0, total: 0 };

      var starsEl = ratingEl.querySelector('.product-card__stars');
      var valEl   = ratingEl.querySelector('.product-card__rating-value');
      var cntEl   = ratingEl.querySelector('.product-card__rating-count');

      if (starsEl) starsEl.innerHTML   = buildStars(stats.avg);
      if (valEl)   valEl.textContent   = parseFloat(stats.avg).toFixed(1);
      if (cntEl)   cntEl.textContent   = formatCount(stats.total);
    });
  }

  /* Run on DOMContentLoaded */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }

  /* Re-run on Shopify Theme Editor section reload (live preview) */
  document.addEventListener('shopify:section:load',   updateAll);
  document.addEventListener('shopify:section:select', updateAll);
  
  /* Re-run when reviews data is loaded/merged */
  document.addEventListener('reviews:loaded', updateAll);

})();
